import * as React from 'react';

import CampaignPayoutsListSummary from 'modules/campaigns/components/payments/payouts/list/summary/CampaignPayoutsListSummary';
import CampaignPayoutsListItems from 'modules/campaigns/components/payments/payouts/list/items/CampaignPayoutsListItems';
import CampaignPayoutsListUnallocated from 'modules/campaigns/components/payments/payouts/list/unallocated/CampaignPayoutsListUnallocated';

import { renderPrice } from 'utils/helper/price';
import { getAcceptedOfferBudget, getExpectedPayoutDateWithRelationToReleaseStatus, getUnallocatedAmount } from 'utils/payouts';
import { t } from 'utils/language';

import './subcampaign-payouts-list.scss';

import type { Campaign, PaymentInfo, Payout, Subcampaign } from 'types';

type Props = {
  payouts: Array<Payout>,
  paymentInfo: PaymentInfo,
  campaign: Campaign,
  subcampaign: Subcampaign,
  variablePaymentsAmount: number
};

class SubcampaignPayoutsList extends React.PureComponent<Props> {
  getTotalPaid = (): number => {
    const { payouts } = this.props;
    let total = 0;

    payouts.forEach(payout => {
      total += payout.executed ? payout.amount : 0;
    });

    return total;
  };

  render(): React.ReactNode {
    const { payouts, subcampaign, campaign, variablePaymentsAmount, paymentInfo } = this.props;

    const totalPaid = this.getTotalPaid();
    const offerBudget = getAcceptedOfferBudget(subcampaign);
    const payoutTotal = offerBudget + variablePaymentsAmount;
    const toBePaidTotal = (payoutTotal - totalPaid) || 0;
    const displayDate = getExpectedPayoutDateWithRelationToReleaseStatus(new Date(), campaign.endDate);
    const unallocatedAmount = getUnallocatedAmount(payouts, subcampaign, paymentInfo);

    return (
      <section
        className="subcampaign-payouts-list"
        data-qa="subcampaign-payouts-list"
      >
        <CampaignPayoutsListSummary
          data={{
            payout: {
              label: t('campaign_payouts.label_payout_list_total_payout'),
              total: renderPrice(payoutTotal)
            },
            released: {
              label: t('campaign_payouts.label_payout_list_paid'),
              total: renderPrice(totalPaid)
            },
            remaining: {
              label: t('campaign_payouts.label_payout_list_to_be_paid'),
              total: renderPrice(toBePaidTotal)
            }
          }}
        />
        <CampaignPayoutsListItems
          headerItems={[
            t('campaign_payouts.label_items_amount'),
            t('campaign_payouts.label_items_payout_expected'),
            t('campaign_payouts.label_items_status')
          ]}
          listItems={payouts}
          campaignId={campaign.id}
          subcampaign={subcampaign}
        />
        {
          unallocatedAmount > 0 && (
            <CampaignPayoutsListUnallocated
              campaign={campaign}
              subcampaign={subcampaign}
              remainingTotal={unallocatedAmount}
              endDate={displayDate}
            />
          )
        }
      </section>
    );
  }
}

export default SubcampaignPayoutsList;
